export default __webpack_public_path__ + "static/sanjayRakesh1-bfac23ab00e3eb471dc854901374d6ad.jpg";